import {createFileRoute} from '@tanstack/react-router';
import {BillRouter} from '../../../../../domains/post-purchase/BillRouter';

export const Route = createFileRoute('/_protected/home/statements/$id/')({
  component: BillRouter,
});
